import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';

import { EventSourcePolyfill } from 'event-source-polyfill';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { DeviceService } from '../devices/device.service';

@Injectable({
  providedIn: 'root'
})
export class SseService implements OnDestroy {

  private url = environment.baseUrl;
  eventSource: EventSource | EventSourcePolyfill;

  device: string;

  constructor(
    private _zone: NgZone,
    private _device: DeviceService,
    private cookieService: CookieService
  ) { }

  getEventSource(device: string): EventSource | EventSourcePolyfill {
    let headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.cookieService.get('access_token')
    }

    if(this.device != device || !this.device){
      if(this.device)
        this.closeEventSource();

      // Usar EventSourcePolyfill si está disponible, sino EventSource nativo
      const EventSourceClass = (window as any).EventSourcePolyfill || EventSource;
      this.eventSource = new EventSourceClass(
        this.url + '/user/' + this._device.user + '/device/' + device + '/eventSSE',
        { headers }
      );
    }
    this.device = device;
    return this.eventSource;
  }

  public getServerSentEvent(): Observable<any> {
    return new Observable((observer: any) => {
      this.eventSource.onmessage = (event: MessageEvent) => {
        this._zone.run(() => {
          observer.next(event)
        })
      };

      this.eventSource.onopen = (a: Event) => {
        console.log('opened')
      };

      //     eventSource.onerror = (e) => {
      //       // Do stuff here
      //     }
     })
  }

  ngOnDestroy(){
    this.closeEventSource();
  }

  closeEventSource(){
    //this.eventSource.removeAllListeners();
    this.eventSource.close();
  }

}
